import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import getLanguageDataById from '@core/utils/helpers/getLanguageDataById'
import React from 'react'
import './ApplyV2ReviewApplyLanguages.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    className?: string
}

const baseClass = 'ApplyV2ReviewApplyLanguages'

function ApplyV2ReviewApplyLanguages({ className = '' }: Props) {
    const { t } = useTranslation()
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const data = postProfileData?.data?.language || []

    const getProficiencyName = (id: number) => {
        switch (id) {
            case 1:
                return `${t('2146')}`
            case 2:
                return `${t('2147')}`
            case 3:
                return `${t('2148')}`
            case 4:
                return `${t('2149')}`
            case 5:
                return `${t('2150')}`
        }
    }
    return (
        <div className={`${baseClass} ${className}`}>
            {data.map((item) => (
                <div key={item.uid || item.existingId} className={`${baseClass}__item `}>
                    <div className={`${baseClass}__item-name`}>{getLanguageDataById(item.worldLanguageId)?.name}</div>
                    <div className={`${baseClass}__item-level`}>{getProficiencyName(item.languageLevelId)}</div>
                </div>
            ))}
        </div>
    )
}

export default ApplyV2ReviewApplyLanguages
